$(document).ready(function()
{

  var acc = document.getElementsByClassName("toggleTitle");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      this.classList.toggle("arrow-open");
      var toggleContent = this.nextElementSibling;
      if (toggleContent.style.display === "block") {
        toggleContent.style.display = "none";
      } else {
        toggleContent.style.display = "block";
      }
    });
  }
})

function navigationMenuSection(){
  const navigationMenus = document.querySelectorAll('.navigation-menu');
  console.log('navigationMenus', navigationMenus);

  navigationMenus.forEach(item => {
      const menuTrigger = item.querySelector('.mobile-menu-trigger');

      menuTrigger.addEventListener('click', () => {
        console.log('click insection-blocks__accordion-item ')
        navigationMenus.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
          }
        });

        item.classList.toggle('active');
      });
  });
}

document.addEventListener('DOMContentLoaded', (evt) => {
  navigationMenuSection();

  var isSafari = /^Apple/.test(navigator.vendor) && !/CriOS|FxiOS/.test(navigator.userAgent);
  
  if (isSafari) {
      document.querySelector('body').classList.add('is-safari');
  }
})

// Fix PDP Button on scroll
function addtoCartCheckScroll() {
  var scrollPosition = window.scrollY;
  var PDPaddtoCartForm = document.querySelector("body:not(.suffix-personalization) .block-buy-buttons.block-buy-buttons.product-block");
  
  if (PDPaddtoCartForm) {
      var elementOffset = PDPaddtoCartForm.getBoundingClientRect().top + window.scrollY;
      var distance = elementOffset + 50; // 50px below the element

      if (scrollPosition > distance) {
        PDPaddtoCartForm.classList.add("make-fix");
      } else {
        PDPaddtoCartForm.classList.remove("make-fix");
      }
  }
}
function addtoCartBlockClickWhenFixed( ele ) {

  
}

window.addEventListener("scroll", addtoCartCheckScroll);

var PDPaddtoCartBtn = document.querySelector(".block-buy-buttons.block-buy-buttons.product-block button");

if(PDPaddtoCartBtn){
  PDPaddtoCartBtn.addEventListener("click", function( event ){
    var PDPaddtoCartForm = PDPaddtoCartBtn.closest(".block-buy-buttons.product-block");
  
    if(PDPaddtoCartForm && PDPaddtoCartForm.classList.contains('make-fix')){
      event.preventDefault();
  
      if (PDPaddtoCartForm) {
        document.querySelector('.product-grid__content.product--description').scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  
  });
}
